import { topconTheme } from './topcon/topconTheme';
import { sdfTheme } from './sdf/sdfTheme';
import { topconNotificationsIconsStyle, topconNotificationsStyle } from './topcon/notifications';
import { sdfNotificationsIconsStyle, sdfNotificationsStyle } from './sdf/notifications';
import { oilsteelTheme } from './oilsteel/oilsteelTheme';
import { oilsteelNotificationsIconsStyle, oilsteelNotificationsStyle } from './oilsteel/notifications';
import { tritecnicaTheme } from './tritecnica/tritecnicaTheme';
import { tritecnicaNotificationsIconsStyle, tritecnicaNotificationsStyle } from './tritecnica/notifications';
import { triolietTheme } from './trioliet/triolietTheme';
import { triolietNotificationsIconsStyle, triolietNotificationsStyle } from './trioliet/notifications';
import { theme as kvernelandTheme } from './kverneland/theme';
import { notificationsIconsStyle as kvernelandNotificationsIconsStyle, notificationsStyle as kvernelandNotificationsStyle, } from './kverneland/notifications';
import { hubfarmTheme } from './hubfarm/hubfarmTheme';
import { hubfarmNotificationsIconsStyle, hubfarmNotificationsStyle } from './hubfarm/notifications';
import { theme as cnhTheme } from './cnh/theme';
import { notificationsIconsStyle as cnhNotificationsIconsStyle, notificationsStyle as cnhNotificationsStyle, } from './cnh/notifications';
import { colomboTheme } from './colombo/colomboTheme';
import { colomboNotificationsIconsStyle, colomboNotificationsStyle } from './colombo/notifications';
export var TENANTS;
(function (TENANTS) {
    TENANTS["TOPCON"] = "ab1078f6-4db4-4209-a450-82c6a95a1068";
    TENANTS["SDF"] = "9a1e17f2-ef68-49e7-b9e2-cac09ce428d6";
    TENANTS["OILSTEEL"] = "d5fa32f1-2584-4d98-afa6-8ef41f7ae92d";
    TENANTS["TRITECNICA"] = "e59faf51-4730-498e-ad14-42ef21c188f9";
    TENANTS["TRIOLIET"] = "07af0065-2f01-4636-919b-8721e872bbad";
    TENANTS["KVERNELAND"] = "328d0660-e305-4469-aaa0-f3e97ec866d2";
    TENANTS["HUBFARM"] = "819c41db-7f8d-457b-ba71-5a8cdef71fc3";
    TENANTS["CNH"] = "b27fed10-0fd7-4685-928b-b30f189b37d8";
    TENANTS["COLOMBO"] = "f85a443b-b3c1-433d-a368-4cc7f98ac2b2";
})(TENANTS || (TENANTS = {}));
const themeByTenantMap = {
    [TENANTS.TOPCON]: {
        name: 'topcon',
        theme: topconTheme,
        notificationsStyle: topconNotificationsStyle,
        notificationsIconsStyle: topconNotificationsIconsStyle,
    },
    [TENANTS.TRITECNICA]: {
        name: 'tritecnica',
        theme: tritecnicaTheme,
        notificationsStyle: tritecnicaNotificationsStyle,
        notificationsIconsStyle: tritecnicaNotificationsIconsStyle,
    },
    [TENANTS.SDF]: {
        name: 'sdf',
        theme: sdfTheme,
        notificationsStyle: sdfNotificationsStyle,
        notificationsIconsStyle: sdfNotificationsIconsStyle,
    },
    [TENANTS.OILSTEEL]: {
        name: 'oilsteel',
        theme: oilsteelTheme,
        notificationsStyle: oilsteelNotificationsStyle,
        notificationsIconsStyle: oilsteelNotificationsIconsStyle,
    },
    [TENANTS.TRIOLIET]: {
        name: 'trioliet',
        theme: triolietTheme,
        notificationsStyle: triolietNotificationsStyle,
        notificationsIconsStyle: triolietNotificationsIconsStyle,
    },
    [TENANTS.KVERNELAND]: {
        name: 'kverneland',
        theme: kvernelandTheme,
        notificationsStyle: kvernelandNotificationsStyle,
        notificationsIconsStyle: kvernelandNotificationsIconsStyle,
    },
    [TENANTS.HUBFARM]: {
        name: 'hubfarm',
        theme: hubfarmTheme,
        notificationsStyle: hubfarmNotificationsStyle,
        notificationsIconsStyle: hubfarmNotificationsIconsStyle,
    },
    [TENANTS.CNH]: {
        name: 'cnh',
        theme: cnhTheme,
        notificationsStyle: cnhNotificationsStyle,
        notificationsIconsStyle: cnhNotificationsIconsStyle,
    },
    [TENANTS.COLOMBO]: {
        name: 'colombo',
        theme: colomboTheme,
        notificationsStyle: colomboNotificationsStyle,
        notificationsIconsStyle: colomboNotificationsIconsStyle,
    },
};
export const getThemeByTenantId = (tenantId) => themeByTenantMap[tenantId];
//# sourceMappingURL=tenants.js.map